import { useEffect, useState } from 'react';

// const baseUrl = "http://localhost:3001" //DEV
const baseUrl = 'https://cwc-backend-heroku.herokuapp.com'; //PRODUCTION

const usePublicApi = (path) => {
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState(null);

	const fetchData = async () => {
		//reset the data and loading
		setLoading(true);
		setData(null);
		const url = `${baseUrl}${path}`;
		try {
			const response = await fetch(url);
			const apiData = await response.json();
			console.log('API DATA', apiData);
			setData(apiData);
			setLoading(false);
		} catch (error) {
			setError(error);
			return console.error(error);
		}
	};

	useEffect(() => {
		if (!path) return;

		fetchData();
		return () => {
			setData(null);
			setLoading(true);
		};
	}, [path]);

	return { error, loading, data, fetchData };
};

export default usePublicApi;
